import {Component} from '@angular/core';
import { MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {ModalHeaderComponent} from '../../../layout/modal-header/modal-header.component';

@Component({
    selector: 'app-output-path-info',
    templateUrl: './output-path-info.component.html',
    styleUrls: ['./output-path-info.component.scss'],
    imports: [ModalHeaderComponent, MatDialogContent]
})
export class OutputPathInfoComponent {
  constructor(
    public dialogRef: MatDialogRef<OutputPathInfoComponent>,
  ) { }
}
